import { render, staticRenderFns } from "./tableIcon.vue?vue&type=template&id=210a7415&"
import script from "./tableIcon.vue?vue&type=script&lang=js&"
export * from "./tableIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports